import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit ground tile: a 1x1 m slab exactly 0.06 thick (top at y = 0.06),
// centred on the origin, seating seamlessly against every other ground tile.
const ASPHALT = "#3f4044";

export const roadPlain = defineModel({
  id: "road-plain",
  batchId: "modern",
  name: "Road (plain)",
  tags: ["modern", "outdoor", "ground", "street", "road", "asphalt", "parking"],
  summary: "A plain unmarked asphalt tile.",
  description:
    "A one-tile plain asphalt slab of the Modern Living kit: exactly 1x1 m " +
    "and 0.06 m thick, no markings — the filler for wide asphalt areas, " +
    "parking lots and intersection interiors. Tiles seamlessly with every " +
    "other ground piece.",
  tiles: { w: 1, h: 1 },
  footprint: 0.75,
  parts(): Part[] {
    return [
      { geometry: new THREE.BoxGeometry(1.0, 0.06, 1.0), color: ASPHALT, position: [0, 0.03, 0] },
    ];
  },
  animations: [],
});
